module.exports = __webpack_public_path__ + "media/images/icon-3c8cba2e.svg";